import React, { useState } from "react";
import { Button, Pagination, Space, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/lib/table";
import { CONSTANT } from "../../../../config/Constant";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment-timezone";
import UpdateForm from "./UpdateForm";
import DeleteForm from "./DeleteForm";
import { PaginationProps } from "antd/lib/pagination";

interface DataType {
  key: string;
  id: string | any;
  code: string | any;
  code_name: string | any;
  description: string | any;
  process_status: string | any;
  created_date: string | any;
}

export const convertDateToIsrael = async (dateTime) => {
  const utcMoment = moment.utc(dateTime, "YYYY-MM-DDTHH:mm:ss");
  const israelMoment = utcMoment.tz("Asia/Jerusalem");
  const israelTime = israelMoment.tz("Asia/Jerusalem"); //.format('YYYY-MM-DDTHH:mm:ss')
  return israelTime;
};

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    tableloading,
    getList,
    totalData,
    paginationData,
    setPaginationData,
    setTableLoading,
  } = props;

  const [openUpdateModal, setOpenUpdateModal] = useState<boolean>(false);
  const [openUpdateData, setOpenUpdateData] = useState<any>();

  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();

  // const userDetails = localStorage.getItem('userDetails');
  // const userRoles = userDetails && JSON.parse(userDetails)?.roles;

  const data: DataType[] = listData?.map((item, index) => ({
    key: index?.toString(),
    id: item?.index ?? index + 1,
    _id: item?._id,
    code: item?.code,
    code_name: item?.code_name,
    description: item?.description,
    process_status: item?.process_status,
    created_date: item?.created_date,
  }));

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 80,
      fixed: "left",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.id.toString().localeCompare(b.id),
    },

    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.code || "").localeCompare(b.code || ""),
      render: (_, record) => {
        return record?.code ? record?.code : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Code Name",
      dataIndex: "code_name",
      key: "code_name",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.code_name || "").localeCompare(b.code_name || ""),
      render: (_, record) => {
        return record?.code_name ? record?.code_name : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 180,
      //
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a.description || "").localeCompare(b.description || ""),
      render: (_, record) => {
        return record?.description
          ? record?.description
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.created_date?.toString().localeCompare(b?.created_date),
      render: (_, record) => {
        return record?.created_date
          ? record?.created_date
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 150,
      fixed: "right",
      // hidden: !checkPrivileges(userRoles, 'admin'),
      render: (_, record, index) => (
        <Space size="middle" wrap>
          <Tooltip
            title={
              record?.process_status === "Complete"
                ? "Can't Update it. This request is already closed."
                : "Update Request"
            }
          >
            <Button
              type="default"
              icon={<EditOutlined />}
              className="EditBtn iconBtn"
              onClick={() => {
                handleUpdateRequest(record);
              }}
              disabled={record?.process_status === "Complete" ? true : false}
            />
          </Tooltip>
          <Tooltip
            title={
              record?.process_status === "Complete"
                ? "Can't cancel it. This request is already closed."
                : "Delete Request"
            }
          >
            <Button
              onClick={() => {
                handleDeleteRequest(record);
              }}
              icon={<DeleteOutlined />}
              type="default"
              className="cancelBtn iconBtn"
              disabled={record?.process_status === "Complete" ? true : false}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleUpdateRequest = (record: any) => {
    setOpenUpdateModal(!openUpdateModal);
    setOpenUpdateData(record);
  };

  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(!openDeleteModal);
    setOpenDeleteData(record);
  };

  const handleDeleteRequestClose = (record: any) => {
    setOpenDeleteModal(false);
    setOpenDeleteData({});
  };

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={"fixed"}
        />
      </div>
      <div className="text-center mt-20 mb-30">
        <Pagination
          defaultCurrent={1}
          current={paginationData?.current}
          total={totalData ?? 0}
          onChange={handleChange}
          responsive={true}
          pageSize={paginationData?.page_size ?? 10}
          showSizeChanger={totalData ? true : false}
          // showSizeChanger
          onShowSizeChange={onShowSizeChange}
          pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
        />
      </div>
      <UpdateForm
        handleUpdateRequest={handleUpdateRequest}
        openUpdateModal={openUpdateModal}
        openUpdateData={openUpdateData}
        getList={getList}
      />

      <DeleteForm
        title={openDeleteData?.code}
        close={handleDeleteRequestClose}
        open={openDeleteModal}
        deleteValues={openDeleteData?._id}
        name={"Code"}
        getList={getList}
      />
    </>
  );
};
export default ListTable;
